import type { TransactionListItem } from "@common/schemas/transaction.schema";
import { useBulkActions } from "@components/transactions/TransactionsBulkActions/useBulkActions";
import { identity } from "../../chatDrag/identity";
import { useRowChatDrag } from "../../chatDrag/useRowChatDrag";
import { useAddTransactionsToChat } from "../../useAddReferencesToChat";

/** `rowDragOut` for the transactions table: drags transactions into the task chat. */
export function useTransactionRowChatDrag() {
    const { canAddToChat, addTransactionsToChat } = useAddTransactionsToChat();
    const { selectedArray, hasSelectedAll, clearSelection } = useBulkActions();
    return useRowChatDrag({
        noun: "transaction",
        canAddToChat,
        getRowItem: identity<TransactionListItem>,
        selectedItems: selectedArray,
        isSelectAll: hasSelectedAll,
        addToChat: addTransactionsToChat,
        clearSelection,
    });
}
